var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcAdminBox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.02659 3.65358C4.56902 3.20294 5.25407 3 6 3H18C18.7153 3 19.3972 3.18731 19.9462 3.6281C20.4965 4.07001 20.8413 4.70914 20.9857 5.47899L22.4839 12.5955C22.4946 12.6463 22.5 12.6981 22.5 12.75V18L22.5 18.0022C22.4977 18.7965 22.1811 19.5577 21.6194 20.1194C21.0577 20.6811 20.2965 20.9977 19.5022 21L19.5 21H4.5L4.49782 21C3.70346 20.9977 2.94229 20.6811 2.38059 20.1194C1.81889 19.5577 1.50231 18.7965 1.5 18.0022L1.5 18V12.75C1.5 12.6981 1.50539 12.6463 1.51609 12.5955L3.0148 5.4766C3.15799 4.73851 3.48626 4.10247 4.02659 3.65358ZM4.98512 4.80736C4.76539 4.98991 4.57839 5.28885 4.48651 5.76664C4.48568 5.77093 4.48481 5.77522 4.48391 5.77951L3 12.8281V17.9988C3.00141 18.3965 3.16002 18.7775 3.44125 19.0587C3.72251 19.34 4.10356 19.4986 4.50128 19.5H19.4987C19.8964 19.4986 20.2775 19.34 20.5587 19.0587C20.84 18.7775 20.9986 18.3964 21 17.9987V12.8281L19.5161 5.77951C19.5148 5.77354 19.5136 5.76756 19.5125 5.76157C19.4215 5.27001 19.2279 4.97506 19.007 4.79768C18.7824 4.61738 18.4565 4.5 18 4.5H6C5.52718 4.5 5.20441 4.62518 4.98512 4.80736Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.5 12.75C1.5 12.3358 1.83579 12 2.25 12H9C9.41421 12 9.75 12.3358 9.75 12.75C9.75 13.1642 9.41421 13.5 9 13.5H2.25C1.83579 13.5 1.5 13.1642 1.5 12.75Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.25 12.75C14.25 12.3358 14.5858 12 15 12H21.75C22.1642 12 22.5 12.3358 22.5 12.75C22.5 13.1642 22.1642 13.5 21.75 13.5H15C14.5858 13.5 14.25 13.1642 14.25 12.75Z",
    fill: "current"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 12C9.41421 12 9.75 12.3358 9.75 12.75C9.75 13.3467 9.98705 13.919 10.409 14.341C10.831 14.7629 11.4033 15 12 15C12.5967 15 13.169 14.7629 13.591 14.341C14.0129 13.919 14.25 13.3467 14.25 12.75C14.25 12.3358 14.5858 12 15 12C15.4142 12 15.75 12.3358 15.75 12.75C15.75 13.7446 15.3549 14.6984 14.6516 15.4016C13.9484 16.1049 12.9946 16.5 12 16.5C11.0054 16.5 10.0516 16.1049 9.34835 15.4016C8.64509 14.6984 8.25 13.7446 8.25 12.75C8.25 12.3358 8.58579 12 9 12Z",
    fill: "current"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.75C6 6.33579 6.33579 6 6.75 6H17.25C17.6642 6 18 6.33579 18 6.75C18 7.16421 17.6642 7.5 17.25 7.5H6.75C6.33579 7.5 6 7.16421 6 6.75Z",
    fill: "current"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.25 9.75C5.25 9.33579 5.58579 9 6 9H18C18.4142 9 18.75 9.33579 18.75 9.75C18.75 10.1642 18.4142 10.5 18 10.5H6C5.58579 10.5 5.25 10.1642 5.25 9.75Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcAdminBox);
export default __webpack_public_path__ + "static/media/ic_admin_box.bdd19f4d70b1a3ed6d4f66162f781140.svg";
export { ForwardRef as ReactComponent };